import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import { Form, Text, Number as NumberInput, Select } from 'components/forms'
import { notEmpty } from 'helpers/validators'
import Button from 'components/Button'
import Divider from 'components/Divider'
import listLoyaltyCardGroups from '../gql/listLoyaltyCardGroups'

const TransactionsModal = ({ data = {}, onSubmit, requesting }) => {
	const [t] = useTranslation()

	return(
		<div>
			<p>{t('common.strings.card')}</p>
			<Row>
				<Col xs={6}>
					<Text
						noForm
						label={t('common.fields.code')}
						value={`${data?.id || ''} - ${data?.name || ''}`}
						disabled
					/>
				</Col>
				<Col xs={6}>
					<NumberInput
						noForm
						label={t('loyalty_card_section.fields.balance')}
						disabled
						value={data?.balance || ''}
						precision={2}
						shrink
						inline
						withControls={false}
					/>
					<NumberInput
						noForm
						label={t('loyalty_card_section.fields.points')}
						disabled
						value={data?.points || ''}
						shrink
						inline
						withControls={false}
					/>
				</Col>
			</Row>
			<Divider visible />
			<p>{t('loyalty_card_section.strings.booking')}</p>
			<Form onSubmit={onSubmit}>
				{({ formApi }) => (
					<>
						<Row>
							<Col xs={6}>
								<Select
									field='groupId'
									label={t('loyalty_card_section.strings.group')}
									remoteOptions={{
										query: listLoyaltyCardGroups
									}}
									valueField='id'
									labelField='name'
									{...notEmpty()}
									validateOnChange
								/>
								<NumberInput
									field='increase'
									label={t('loyalty_card_section.strings.credit')}
									onChange={() => {
										if(formApi.getValue('decrease')) {
											formApi.setValue('decrease', null)
										}
									}}
									precision={2}
									withControls={false}
									shrink
									inline
								/>
								<NumberInput
									field='decrease'
									label={t('loyalty_card_section.strings.charge')}
									onChange={() => {
										if(formApi.getValue('increase')) {
											formApi.setValue('increase', null)
										}
									}}
									precision={2}
									withControls={false}
									shrink
									inline
								/>
							</Col>
							<Col xs={6}>
								<Text
									field='name'
									label={t('common.fields.name')}
									{...notEmpty()}
									validateOnChange
								/>
								<NumberInput
									field='points'
									label={t('loyalty_card_section.fields.points')}
									disabled={!data?.isPointsActive}
									withControls={false}
									shrink
								/>
							</Col>
						</Row>
						<Divider />
						<Button type='submit' text={t('loyalty_card_section.strings.booking_transaction')} loading={requesting} />
					</>
				)}
			</Form>
		</div>
	)
}

TransactionsModal.propTypes = {
	onSubmit: PropTypes.func.isRequired
}

export default TransactionsModal
